/** @format */

import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ReportPage.css";

import NavbarTH from "./Navbar-TH";

import BannerTH from "./Banner-TH";

import ReportTH from "./ReportTH";

import FollowPageOldTH from "./FollowPageOldTH";

import FooterTH from "../menu/Footer-TH";

import { useSelector, useDispatch } from "react-redux";
import { savePageRoute } from "../store/RouteSlice";

export default function ReportPage() {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // Dispatch page route based on current pathname
    if (location.pathname.startsWith("/report")) {
      dispatch(savePageRoute("report"));
    } else if (location.pathname.startsWith("/track")) {
      dispatch(savePageRoute("track"));
    } else {
      dispatch(savePageRoute("report"));
    }
  }, [location.pathname, globalData.language.toggle_language]);

  return (
    <div
      className="container-all"
      style={{
        backgroundColor: "#FAFAFA",
      }}>
      <div>
        <NavbarTH />
      </div>

      <div className="container-report-page">
        <Routes>
          <Route path="/report" element={<ReportTH />} />
          <Route path="/track/*" element={<FollowPageOldTH />} />
        </Routes>
      </div>

      {globalData.pageRoute.pageRoute === "report" && (
        <div>
          <BannerTH />
        </div>
      )}

      <div>
        <FooterTH />
      </div>
    </div>
  );
}
